import React, { Component, Fragment } from 'react'
import Breadcrumbs from '../../shared/Breadcrumbs'
import { ReportFiltersRoute } from '../../routing'

export  class ReportFilterPage extends Component {
    render() {
        return (
            <Fragment>
                <Breadcrumbs />
                <ReportFiltersRoute />
            </Fragment>
        )
    }
}
